import { classNames } from 'primereact/utils';
import { TextBodyMedium, TextLabelLarge2 } from '../text/Texts';
import { cn } from '../ui/cn';

interface Props {
	description?: string;
	title: string;
	src: string;
	className?: string;
	imageClassName?: string;
	titleClassName?: string;
	descriptionClassName?: string;
}

const EmptyTable = ({
	title, description, src,
	className, imageClassName, descriptionClassName, titleClassName,
}: Props) => {
	return (
		<div className={classNames(className, 'text-center min-h-80 content-center')}>
			<img
				className={classNames(imageClassName, 'mx-auto')}
				alt="empty-state-image"
				src={src} width={200} height={200}
			/>
			{title && (<TextLabelLarge2 text={title} className={cn('text-black', titleClassName)} />)}
			{description && (<TextBodyMedium text={description} className={cn('text-black', descriptionClassName)} />)}
		</div>
	);
};

export default EmptyTable;
